import { BDropdownItemButton } from 'bootstrap-vue';
import i18n from '@/utils/i18n';
import store from '@/store';
import defaultRoutes from './routes';
import defaultRoutesLocales from './routesLocales';
export default class routerProvider {
  constructor() {
    this.routes = defaultRoutes;

    this.routeLocales = defaultRoutesLocales;

    this.routesWithLocales = [];
  }

  getRoutesWithLocales() {
    this.routesWithLocales = this.routes.map(item => {
      let routeWithLocale = this.routeLocales.find(subItem => subItem.name === item.name);
      if (routeWithLocale) {
        item.path = routeWithLocale.path;
        item.alias = Object.values(routeWithLocale.locales);
        item.meta = {
          locales: { ...routeWithLocale.locales, en: routeWithLocale.path },
        };
      }

      return item;
    });

    return this.routesWithLocales;
  }

  matchURL(name) {
    let routeLocale = this.routeLocales.find(item => item.name === name);
    if (routeLocale) {
      return store.state.settings.selectedLocale.short_code === 'en'
        ? routeLocale.path
        : routeLocale.locales[store.state.settings.selectedLocale.short_code];
    }

    return false;
  }

  routeSwitchControl(to) {
    let currentParentURL = to.path.split('/')[1];
    let matchedUrl = this.matchURL(to.matched.length ? to.matched[0].name : null);
    if (to.matched && matchedUrl && currentParentURL !== matchedUrl.replace('/', '')) {
      return to.path.replace(currentParentURL, matchedUrl.replace('/', ''));
    }

    return false;
  }
}
